import React from "react";

export default function SQLServer_EXP() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_EXP</h1>
      <p>This is the SQLServer_EXP component generated from the SQL JSON.</p>
    </div>
  );
}
